import { useEffect } from "react";
import { useLocation, Navigate, Link } from "react-router-dom";
import { findPolicy } from "@/lib/policies";
import PageHero from "@/components/PageHero";

const PolicyPage = () => {
  const { pathname } = useLocation();
  const slug = pathname.replace(/^\//, "").split("/")[0]; // 'privacy' | 'cookies' | 'safeguarding'
  const policy = findPolicy(slug);

  useEffect(() => {
    if (policy) {
      document.title = `${policy.title} | SeaShells Care`;
    }
  }, [policy]);

  if (!policy) return <Navigate to="/" replace />;

  return (
    <main data-testid={`page-policy-${slug}`}>
      <PageHero
        eyebrow="Our policies"
        title={policy.title}
        subtitle={policy.intro}
      />

      <section className="section">
        <div className="container-px max-w-3xl mx-auto">
          <div className="space-y-10">
            {policy.sections.map((s, i) => (
              <div key={i} data-testid={`policy-section-${i + 1}`}>
                <h2 className="font-serif text-2xl md:text-3xl text-[var(--ss-teal-800)]">
                  {s.h}
                </h2>
                <div className="mt-4 space-y-3 text-[var(--ss-ink-soft)] leading-relaxed">
                  {s.p.map((para, pi) => (
                    <p key={pi}>{para}</p>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <hr className="my-12 border-[var(--ss-line)]" />

          <div className="text-sm text-[var(--ss-ink-soft)]">
            Questions about this policy? Get in touch at{" "}
            <a
              href="mailto:info@seashellcare.com"
              className="text-[var(--ss-teal-700)] font-semibold underline"
            >
              info@seashellcare.com
            </a>{" "}
            or call 01992 892894.
          </div>

          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/privacy" className="btn btn-outline-dark">Privacy</Link>
            <Link to="/cookies" className="btn btn-outline-dark">Cookies</Link>
            <Link to="/safeguarding" className="btn btn-outline-dark">Safeguarding</Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default PolicyPage;
